export default __webpack_public_path__ + "static/media/Modelhomepage_GIF_final.7071b8d7.png";